import React from "react";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "./plusIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Routes(props: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={styles.switch}
      onClick={(e) => {
        e.stopPropagation();
        props.switch();
      }}
    >
      <div className={styles.iconBox}>
        <PlusIcon className={styles.icon} />
      </div>
      <p className={styles.paragraph}>{t("statusCreationForm.addStatus")}</p>
    </div>
  );
}

export { Routes };
